import { useState } from "react";
import { RiArrowDownSLine } from "react-icons/ri";

import SideProfileInfo from "./SideProfileInfo";
import Information from "./Information";
import SocialMedia from "./SocialMedia";

const SideProfile = () => {
    const [open, setOpen] = useState(false);

    return (
        <div
            className="transition-all duration-500 w-full min-w-[270px] max-w-full lg:max-w-[300px] rounded-3xl overflow-hidden h-fit relative lg:sticky lg:top-10"
            style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.09)",
                backdropFilter: "blur(16px)",
                WebkitBackdropFilter: "blur(16px)",
                boxShadow: "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.04)",
            }}
        >
            {/* Gold accent bar at top */}
            <div
                style={{
                    height: "2px",
                    background:
                        "linear-gradient(90deg, transparent 0%, #C8972A 40%, #F0C060 50%, #C8972A 60%, transparent 100%)",
                    opacity: 0.7,
                }}
            />

            <div className="px-7 py-6">
                <SideProfileInfo />

                {/* ── Desktop separator ── */}
                <div
                    className="hidden lg:block my-6"
                    style={{ height: "1px", background: "rgba(255,255,255,0.07)" }}
                />

                {/* ── Mobile toggle ── */}
                <button
                    onClick={() => setOpen(!open)}
                    className="lg:hidden w-full flex items-center justify-between mt-5 text-gray-500 hover:text-gray-300 transition-colors duration-200"
                    style={{
                        fontSize: "10px",
                        letterSpacing: "0.2em",
                        textTransform: "uppercase",
                        fontWeight: 500,
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                    }}
                >
                    <span>Contact Info</span>
                    <RiArrowDownSLine
                        size={17}
                        className={`transition-transform duration-300 ${open ? "-rotate-180" : ""}`}
                    />
                </button>

                {/* Contact + social — always visible on desktop, toggled on mobile */}
                <div
                    className={`${
                        open ? "max-h-screen mt-4" : "max-h-0"
                    } lg:max-h-full lg:mt-0 overflow-hidden transition-all duration-500`}
                >
                    <Information />

                    <div
                        className="my-5"
                        style={{ height: "1px", background: "rgba(255,255,255,0.06)" }}
                    />

                    <SocialMedia />
                </div>
            </div>
        </div>
    );
};

export default SideProfile;
